import React from 'react'
import RouteConstant from 'constants/RouteConstant'
import CommonLayout from 'layouts/Common'
import {Redirect, Route, Switch} from 'react-router-dom'
import RouteIf from 'routes/RouteIf'

import ProductRegistrationOrganizationList from 'pages/ProductRegistrationOrganization/ProductRegistrationOrganizationList'
import {AllUserRoles} from 'Authority'

export default function ProductRegistrationOrganizationRoute() {
  return (
    <CommonLayout>
      <Switch>
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.PRODUCTS_REGISTRATION_ORGANIZATION.path}
          exact
          component={ProductRegistrationOrganizationList}
        />

        <Route path='*'>
          <Redirect to={RouteConstant.ERROR_NOT_FOUND.path} />
        </Route>
      </Switch>
    </CommonLayout>
  )
}
